import { render } from "./InputField.vue?vue&type=template&id=2b43256a&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"

import "./InputField.vue?vue&type=style&index=0&id=2b43256a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b43256a"]])

export default __exports__